import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Training } from '../../../models/training'
import { ResourcesCssService } from '../../resources/resources-css.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-training',
  templateUrl: './training.component.html',
  styleUrls: ['./training.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainingComponent implements OnInit {

  @Input() training: Training
  constructor(public resourcesCssService: ResourcesCssService,
    private sanitizer: DomSanitizer) { }

  trainingContent: any = ''

  ngOnInit() {
    this.trainingContent = this.sanitizer.bypassSecurityTrustHtml(this.training.content)
  }

  gotoTraining() {
    if (this.training.link) {
      window.open(this.training.link, '_blank')
    }
  }
}
